import { render, staticRenderFns } from "./ImageContentCard.vue?vue&type=template&id=9fa20736"
import script from "./ImageContentCard.vue?vue&type=script&lang=ts"
export * from "./ImageContentCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports